<template>
  <!-- <div> -->
  <a-menu
    :selectedKeys="selectedKeys"
    :openKeys="openKeys"
    mode="inline"
    :theme="theme"
    @openChange="menuSwitch"
  >
    <template v-for="item in menuData">
      <a-menu-item
        v-if="!item.children"
        :key="item.path"
        @click="menuItemClicked"
      >
        <a-icon
          v-if="item.meta.icon"
          :type="item.meta.icon"
          :style="{ fontSize: '18px' }"
        />
        <span>{{item.meta.title}}</span>
      </a-menu-item>
      <sub-menu
        v-else
        :menuInfo="item"
        :key="item.path"
        :menuItemClicked="menuItemClicked"
      />
    </template>
  </a-menu>
  <!-- </div> -->
</template>

<script>
import SubMenu from './SubMenu'

export default {
  name: 'SideMenu',
  props: {
    theme: {
      type: String,
      default: 'dark'
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'sub-menu': SubMenu
  },
  watch: {
    '$route.path': function(newVal) {
      this.selectedKeys = this.selectedKeysMap[newVal]
      this.openKeys = this.collapsed ? [] : this.openKeysMap[newVal]
    }
  },
  data() {
    this.selectedKeysMap = {}
    this.openKeysMap = {}
    this.rootMenuKeys = []
    // this.$router.options.routes 获取路由配置
    const menuData = this.getMenuData(this.$router.options.routes)
    return {
      menuData,
      selectedKeys: this.selectedKeysMap[this.$route.path],
      openKeys: this.collapsed ? [] : this.openKeysMap[this.$route.path]
    }
  },
  methods: {
    menuSwitch(openKeys) {
      if (!this.openKeys) {
        this.openKeys = openKeys
        return
      }

      const latestOpenKey = openKeys.find(
        key => this.openKeys.indexOf(key) === -1
      )
      if (this.rootMenuKeys.indexOf(latestOpenKey) !== -1) {
        this.openKeys = [...this.openKeysMap[latestOpenKey], latestOpenKey]
      } else {
        this.openKeys = [...openKeys]
      }
    },

    menuItemClicked(data) {
      this.$router.push({ path: data.key, query: {} })
    },

    getMenuData(routes = [], parentKeys = [], selectedKey) {
      const menuData = []
      routes.forEach(item => {
        if (item.name && !item.hideInMenu) {
          this.openKeysMap[item.path] = parentKeys
          this.selectedKeysMap[item.path] = [selectedKey || item.path]

          const newItem = { ...item }
          delete newItem.children

          if (item.children && !item.hideChildrenInMenu) {
            this.rootMenuKeys.push(item.path)
            newItem.children = this.getMenuData(item.children, [
              ...parentKeys,
              item.path
            ])
          } else {
            this.getMenuData(
              item.children,
              selectedKey ? parentKeys : [...parentKeys, item.path],
              selectedKey || item.path
            )
          }
          menuData.push(newItem)
        } else if (
          !item.hideInMenu &&
          !item.hideChildrenInMenu &&
          item.children
        ) {
          this.rootMenuKeys.push(item.path)
          menuData.push(
            ...this.getMenuData(item.children, [...parentKeys, item.path])
          )
        }
      })
      return menuData
    }
  }
}
</script>
